<template>
<div v-if="orden">
    <h1 class="subtitle">
        Actualizar estado: Orden de
        {{ orden.tipo_orden === 1 ? "Compra" : "Servicio" }}
        {{ orden.codigo }}
    </h1>
    Estado Actual: {{ orden.estado.descripcion }}
    <b-field label="Nuevo Estado">
        <b-select v-if="estados.length > 0" v-model="estado">
            <option
                v-for="(estado, index) in estados"
                :value="estado"
                :key="index + '_estado'">{{ estado.descripcion }}</option>
        </b-select>
    </b-field>
    <b-field label="Comentarios">
        <b-input v-model="comentarios"> </b-input>
    </b-field>
    <button class="button is-success" @click="updateEstado" :disabled="(!estado || !comentarios) || estado.id_orden_estado === orden.estado.id_orden_estado">
        Actualizar Estado
    </button>
</div>
</template>

<script>
import axios from "axios"
import { purchaseStatus } from "../constants/constants"

export default {
    name: "OrdenImportacion",
    data() {
        return {
            estados: [],
            orden: null,
            status: {},
            comentarios: "",
            estado: null
        }
    },
    methods: {
        loadOrdenData() {
            axios
                .post(
                    "/orden/get-orden-detail",
                    {},
                    { headers: { idOrden: this.getIdOrden() } }
                )
                .then(
                    resp => {
                        this.orden = resp.data
                        this.status.id_orden = this.getIdOrden()
                    },
                    () => { }
                )
        },
        getIdOrden() {
            let path = window.location.pathname
            return path.split("/")[3]
        },
        loadOrdenEstado() {
            const lista = [
                purchaseStatus.FABRICA.id,
                purchaseStatus.ALMACEN_ADUANA.id,
                purchaseStatus.PUERTO_ORIGEN.id,
                purchaseStatus.PUERTO_DESTINO.id,
                purchaseStatus.TRANSITO.id
            ]
            axios.get("/orden/estado/list").then(resp => {
                this.estados = resp.data.filter(e => lista.indexOf(e.id_orden_estado) > -1)
            })
        },
        updateEstado() {
            axios
                .post(
                    "orden/update-status",
                    {
                        id_orden_estado: this.estado.id_orden_estado,
                        descripcion: this.comentarios
                    },
                    {
                        headers: { idOrden: this.getIdOrden() }
                    }
                )
                .then(() => {
                    this.loadOrdenData()
                    this.$buefy.toast.open({
                        message: `Se actualizo la orden`,
                        type: "is-success"
                    })
                })
        }
    },
    mounted() {
        this.loadOrdenData()
        this.loadOrdenEstado()
    }
}
</script>

<style scoped></style>
